import { useCallback } from "react";
import { useAppSelector } from "../../redux";
import { Typography } from "../Typography/Typography";
import * as S from "./KycInstructions.styled";
import { tickIcon, pendingIcon } from "../../assets";
import { TokenType } from "../../constants";

interface KycInstructionsProps {
  kycType: TokenType;
}

export const KycInstructions = ({ kycType }: KycInstructionsProps) => {
  const kycStatus = useAppSelector((state) => state.user.userData.kyc?.status);

  const getVerificationLabel = useCallback(
    () => (kycType === TokenType.COMPANY ? "KYB" : "KYC"),
    [kycType]
  );

  const stepOneSuccess =
    kycStatus === "started" ||
    kycStatus === "approved" ||
    kycStatus === "pending" ||
    kycStatus === "rejected" ||
    kycStatus === "resubmit";
  const stepTwoSuccess =
    kycStatus === "pending" ||
    kycStatus === "approved" ||
    kycStatus === "rejected";
  const stepThreeSuccess = kycStatus === "approved" || kycStatus === "rejected";
  return (
    <S.Container>
      <S.InstructionBox success={stepOneSuccess}>
        <S.SuccessMark success={stepOneSuccess}>
          <img src={stepOneSuccess ? tickIcon : pendingIcon} alt="tick icon" />
        </S.SuccessMark>
        <Typography.Body style={{ textAlign: "center" }} fontWeight={700}>
          Init {getVerificationLabel()} by clicking the button
        </Typography.Body>
        <Typography.BodySmall style={{ textAlign: "center" }} fontWeight={300}>
          Start the identity verification process by choosing on of the
          following: &quot;KYC or KYB&quot; buttons and then clicking the
          &quot;Start verification&quot; button in Our application. Then the
          sumsub pop-up will appear.
        </Typography.BodySmall>
      </S.InstructionBox>
      <S.InstructionBox success={stepTwoSuccess}>
        <S.SuccessMark success={stepTwoSuccess}>
          <img src={stepTwoSuccess ? tickIcon : pendingIcon} alt="tick icon" />
        </S.SuccessMark>
        <Typography.Body style={{ textAlign: "center" }} fontWeight={700}>
          Verify and back
        </Typography.Body>
        <Typography.BodySmall style={{ textAlign: "center" }} fontWeight={300}>
          Follow the instructions on the sumsub pop-up. After successfully
          completing the identity verification process you may exit from the
          popup. If you receive any errors, please try again or contact support.
        </Typography.BodySmall>
      </S.InstructionBox>
      <S.InstructionBox success={stepThreeSuccess}>
        <S.SuccessMark success={stepThreeSuccess}>
          <img
            src={stepThreeSuccess ? tickIcon : pendingIcon}
            alt="tick icon"
          />
        </S.SuccessMark>
        <Typography.Body style={{ textAlign: "center" }} fontWeight={700}>
          Information from {getVerificationLabel()} provider
        </Typography.Body>
        <Typography.BodySmall style={{ textAlign: "center" }} fontWeight={300}>
          We have received information from the identity verification provider.
          Your current status is displayed in the main section.
        </Typography.BodySmall>
      </S.InstructionBox>
    </S.Container>
  );
};
